import { BookingPeriod } from "../GeneratedClients/FreeBillApi";

export const setBookingPeriodToLocalState = (bookingPeriod?: BookingPeriod) => {
  bookingPeriod?.name&&localStorage.setItem("bookingPeriod", bookingPeriod.name);
  bookingPeriod?.startDate&&localStorage.setItem("bookingPeriodStartDate", bookingPeriod.startDate)
  bookingPeriod?.endDate&&localStorage.setItem("bookingPeriodEndDate", bookingPeriod.endDate)
}